const TEMPLATE_MATCHER = /{{\s?([^{}\s]*)\s?}}/g;

export function parseStringTemplate(expression: string, valueObj: { [key: string]: string }) {
  return valueObj ? expression.replace(TEMPLATE_MATCHER, (substring, key) => valueObj[key]) : expression;
}
